import asyncActionTypes from '../actions/types';

const initialState = {
  mealPreselectFlights: [],
};

const mealPreselectFlights = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.RETRIEVE_MEALPRESELECT_FLIGHTS.START:
      return {
        ...state,
        mealPreselectFlights: initialState.mealPreselectFlights,
      };
    case asyncActionTypes.RETRIEVE_MEALPRESELECT_FLIGHTS.SUCCESS:
      return {
        ...state,
        mealPreselectFlights: action?.payload,
      };
    case asyncActionTypes.RETRIEVE_MEALPRESELECT_FLIGHTS.FAIL:
      return {
        ...state,
        mealPreselectFlights:[],
      };
  
    default:
      return state;
  }
};

export default mealPreselectFlights;